import { PORTFOLIO_COMPOSITION, PORTFOLIO_COMPOSITION_ERROR, PORTFOLIO_COMPOSITION_HIDE_ERROR, PORTFOLIO_COMPOSITION_START_LOADER, PORTFOLIO_COMPOSITION_STOP_LOADER, } from "../interface/IPortfolioComposition";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const portfolioCompositionReducer = (state = initState, action) => {
    switch (action.type) {
        case PORTFOLIO_COMPOSITION: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case PORTFOLIO_COMPOSITION_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PORTFOLIO_COMPOSITION_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case PORTFOLIO_COMPOSITION_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case PORTFOLIO_COMPOSITION_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default portfolioCompositionReducer;
